(function () {
  var LEGACY_CONTACT_PAGE_PATH = '/pages/contact';
  var CONTACT_PAGE_PATH = '/pages/contact-legacy';
  var LEGACY_FORM_PREFIX = '/pages/forms/unified-contact-form';
  var LEGACY_PRIVACY_POLICY_PATH = '/policies/privacy-policy';
  var LEGACY_PRIVACY_PAGE_PATH = '/pages/privacy-policy';
  var A2P_PRIVACY_PAGE_PATH = '/pages/contact-and-sms-privacy-policy';
  var SMS_TERMS_PAGE_PATH = '/pages/sms-terms';
  var LEGACY_PAGE_REDIRECTS = {
    '/pages/about-our-store': '/pages/about-us',
    '/pages/answers-to-your-questions': '/pages/support-center',
    '/pages/contact-us': '/pages/contact-legacy',
    '/pages/product-guidelines': '/pages/guideline',
    '/pages/warranty-terms': '/pages/terms-conditions'
  };
  var CONTACT_FORM_COPY = {
    title: 'Request Samples or Wholesale Pricing',
    descriptionText: 'Use this form to request samples, wholesale pricing, or product guidance from Graphictac. A team member will follow up with you shortly.',
    descriptionHtml: '<p>Use this form to request samples, wholesale pricing, or product guidance from Graphictac. A team member will follow up with you shortly.</p>',
    submitText: 'Send Inquiry',
    successTitle: 'Thanks for your inquiry.',
    successMessageHtml: '<p>A member of the Graphictac team will follow up with you shortly.</p>',
    requestTypeError: 'Please select a request type before sending your inquiry.',
    fields: {
      'text-1': {
        currentLabels: ['First Name', 'First Name *', 'First name', 'First name *'],
        baseLabel: 'First name',
        label: 'First name *',
        placeholder: 'Your first name'
      },
      text: {
        currentLabels: ['Shop Name', 'Shop Name *', 'Company name', 'Company name *'],
        baseLabel: 'Company name',
        label: 'Company name *',
        placeholder: 'Your company name'
      },
      email: {
        currentLabels: ['Email', 'Email *', 'Work email', 'Work email *'],
        baseLabel: 'Work email',
        label: 'Work email *',
        placeholder: 'you@company.com'
      },
      'phone-1': {
        currentLabels: ['Phone', 'Phone *', 'Phone number', 'Phone number *'],
        baseLabel: 'Phone number',
        label: 'Phone number *',
        placeholder: 'Best number for follow-up'
      },
      textarea: {
        currentLabels: ['Message', 'Message *', 'Project details', 'Project details *'],
        baseLabel: 'Project details',
        label: 'Project details *',
        placeholder: 'Tell us what products, samples, pricing, or application details you need.'
      }
    },
    requestType: {
      name: 'request_type',
      label: 'Request type *',
      placeholder: 'Select request type',
      options: [
        'Sample Request',
        'Wholesale Inquiry',
        'Promotion Inquiry',
        'General Contact'
      ]
    }
  };
  var TRACKING_FIELD_DEFINITIONS = [
    {
      name: 'utm_source',
      label: 'UTM Source'
    },
    {
      name: 'utm_medium',
      label: 'UTM Medium'
    },
    {
      name: 'utm_campaign',
      label: 'UTM Campaign'
    },
    {
      name: 'utm_content',
      label: 'UTM Content'
    },
    {
      name: 'landing_page',
      label: 'Landing Page'
    },
    {
      name: 'referrer',
      label: 'Referrer'
    },
    {
      name: 'fbclid',
      label: 'FBCLID'
    }
  ];
  var CONTACT_FORM_TEXT_REPLACEMENTS = {
    'Request Free Sample': CONTACT_FORM_COPY.title,
    'Request Free Sample ': CONTACT_FORM_COPY.title,
    'Fill this form to request your free sample vinyl from Graphictac delivered to you in 1-2 days.': CONTACT_FORM_COPY.descriptionText,
    'Fill this form to request your free sample vinyl from Graphictac delivered to you in 1-2 days. After you submit this form, our dedicated sales rep will reach out to you and confirm shipping address.': CONTACT_FORM_COPY.descriptionText,
    'Thanks for requesting the free sample.': CONTACT_FORM_COPY.successTitle,
    'Access Your Free Sample': CONTACT_FORM_COPY.submitText,
    'We appreciate you contacting us. One of our colleagues will get back in touch with you soon!': 'A member of the Graphictac team will follow up with you shortly.',
    'Have a great day!': ''
  };

  function normalizeText(value) {
    return (value || '').replace(/\s+/g, ' ').trim();
  }

  function isLegacyPath(pathname) {
    return typeof pathname === 'string' && pathname.indexOf(LEGACY_FORM_PREFIX) === 0;
  }

  function resolveLegacyHref(href) {
    try {
      var parsed = new URL(href, window.location.origin);
      if (LEGACY_PAGE_REDIRECTS[parsed.pathname]) {
        return LEGACY_PAGE_REDIRECTS[parsed.pathname];
      }

      if (
        parsed.pathname === LEGACY_PRIVACY_POLICY_PATH ||
        parsed.pathname === LEGACY_PRIVACY_PAGE_PATH
      ) {
        return A2P_PRIVACY_PAGE_PATH;
      }

      if (parsed.pathname === LEGACY_CONTACT_PAGE_PATH) {
        return CONTACT_PAGE_PATH;
      }

      if (parsed.pathname === A2P_PRIVACY_PAGE_PATH) {
        return A2P_PRIVACY_PAGE_PATH;
      }

      if (parsed.pathname === SMS_TERMS_PAGE_PATH) {
        return SMS_TERMS_PAGE_PATH;
      }

      return isLegacyPath(parsed.pathname) ? CONTACT_PAGE_PATH : null;
    } catch (error) {
      return null;
    }
  }

  function rewriteAnchor(anchor) {
    if (!anchor || typeof anchor.getAttribute !== 'function') {
      return;
    }

    var href = anchor.getAttribute('href');
    if (!href) {
      return;
    }

    var text = normalizeText(anchor.textContent);
    var replacement = resolveLegacyHref(href);
    if (replacement) {
      anchor.setAttribute('href', replacement);
      if (text === 'Privacy') {
        anchor.textContent = 'Privacy Policy';
      }
      return;
    }

    if (href === 'privacy-policy') {
      anchor.setAttribute('href', A2P_PRIVACY_PAGE_PATH);
      if (text === 'Privacy') {
        anchor.textContent = 'Privacy Policy';
      }
      return;
    }

    if (
      window.location.pathname === CONTACT_PAGE_PATH ||
      window.location.pathname === LEGACY_CONTACT_PAGE_PATH
    ) {
      if (href === 'sms-terms' || href === '/pages/sms-terms') {
        anchor.setAttribute('href', SMS_TERMS_PAGE_PATH);
      }

      if (
        href === 'contact-and-sms-privacy-policy' ||
        href === '/pages/contact-and-sms-privacy-policy'
      ) {
        anchor.setAttribute('href', A2P_PRIVACY_PAGE_PATH);
      }
    }
  }

  function rewriteAllAnchors() {
    document.querySelectorAll('a[href]').forEach(rewriteAnchor);
  }

  function getTrackingFieldValues() {
    var currentUrl = new URL(window.location.href);
    var params = currentUrl.searchParams;

    return {
      utm_source: params.get('utm_source') || '',
      utm_medium: params.get('utm_medium') || '',
      utm_campaign: params.get('utm_campaign') || '',
      utm_content: params.get('utm_content') || '',
      landing_page: currentUrl.toString(),
      referrer: document.referrer || '',
      fbclid: params.get('fbclid') || ''
    };
  }

  function upsertHiddenInput(formElement, name, value) {
    var input = formElement.querySelector('input[name="' + name + '"]');

    if (!input) {
      input = document.createElement('input');
      input.type = 'hidden';
      input.name = name;
      formElement.appendChild(input);
    }

    input.value = value || '';
    return input;
  }

  function updatePowerfulFormBuilderKeyLabels(formElement) {
    var keyLabelInput = formElement.querySelector('input[name="_keyLabel"]');
    var keyLabelMap = {};

    if (!keyLabelInput) {
      return;
    }

    try {
      keyLabelMap = JSON.parse(keyLabelInput.value || '{}');
    } catch (error) {
      keyLabelMap = {};
    }

    TRACKING_FIELD_DEFINITIONS.forEach(function (field) {
      keyLabelMap[field.name] = field.label;
    });

    keyLabelMap.contact_form_route = 'Contact Form Route';
    keyLabelMap.contact_form_owner = 'Contact Form Owner';
    keyLabelMap.request_type = CONTACT_FORM_COPY.requestType.label;
    keyLabelInput.value = JSON.stringify(keyLabelMap);
  }

  function syncPowerfulFormBuilderMetadata(formElement) {
    var trackingValues = getTrackingFieldValues();

    [
      {
        name: 'contact_form_route',
        value: 'contact-legacy'
      },
      {
        name: 'contact_form_owner',
        value: 'info@graphictac.us'
      }
    ].forEach(function (field) {
      var input = upsertHiddenInput(formElement, field.name, field.value);
      input.setAttribute('data-label', field.name);
    });

    TRACKING_FIELD_DEFINITIONS.forEach(function (field) {
      var input = upsertHiddenInput(formElement, field.name, trackingValues[field.name]);
      input.setAttribute('data-label', field.label);
    });

    updatePowerfulFormBuilderKeyLabels(formElement);
  }

  function hydrateNativeContactFormTracking() {
    var trackingValues = getTrackingFieldValues();
    var forms = document.querySelectorAll('form[action*="/contact"]');

    forms.forEach(function (formElement) {
      if (!formElement.querySelector('input[name="form_type"][value="contact"]')) {
        return;
      }

      TRACKING_FIELD_DEFINITIONS.forEach(function (field) {
        var input = formElement.querySelector(
          'input[name="contact[' + field.name + ']"], input[name="' + field.name + '"]'
        );

        if (input) {
          input.value = trackingValues[field.name] || '';
        }
      });
    });
  }

  function patchLocalizedValue(target, value) {
    if (!target) {
      return target;
    }

    if (typeof target === 'string') {
      return value;
    }

    if (typeof target === 'object') {
      if (typeof target.en === 'string') {
        target.en = value;
      } else {
        Object.keys(target).forEach(function (key) {
          if (typeof target[key] === 'string') {
            target[key] = value;
          }
        });
      }
    }

    return target;
  }

  function patchStringContent(value) {
    if (typeof value !== 'string') {
      return value;
    }

    Object.keys(CONTACT_FORM_TEXT_REPLACEMENTS).forEach(function (from) {
      value = value.split(from).join(CONTACT_FORM_TEXT_REPLACEMENTS[from]);
    });

    return value;
  }

  function patchFieldConfig(field) {
    var fieldCopy = CONTACT_FORM_COPY.fields[field.id];

    if (!fieldCopy) {
      return;
    }

    if (typeof field.label === 'string') {
      field.label = fieldCopy.baseLabel;
    } else {
      patchLocalizedValue(field.label, fieldCopy.baseLabel);
    }

    if (typeof field.placeholder === 'string') {
      field.placeholder = fieldCopy.placeholder;
    } else {
      patchLocalizedValue(field.placeholder, fieldCopy.placeholder);
    }

    if (typeof field.description === 'string') {
      field.description = patchStringContent(field.description);
    }
  }

  function patchPowerfulFormBuilderConfig() {
    if (
      window.location.pathname !== CONTACT_PAGE_PATH &&
      window.location.pathname !== LEGACY_CONTACT_PAGE_PATH
    ) {
      return;
    }

    var forms = window.Globo && window.Globo.FormBuilder && window.Globo.FormBuilder.forms;
    if (!forms) {
      return;
    }

    Object.keys(forms).forEach(function (formId) {
      var formConfig = forms[formId];
      if (!formConfig || typeof formConfig !== 'object') {
        return;
      }

      if (formConfig.header) {
        patchLocalizedValue(formConfig.header.title, CONTACT_FORM_COPY.title);
        patchLocalizedValue(formConfig.header.description, CONTACT_FORM_COPY.descriptionHtml);
      }

      if (formConfig.footer) {
        patchLocalizedValue(formConfig.footer.submitText, CONTACT_FORM_COPY.submitText);
      }

      if (formConfig.afterSubmit) {
        patchLocalizedValue(formConfig.afterSubmit.title, CONTACT_FORM_COPY.successTitle);
        if (typeof formConfig.afterSubmit.message === 'string') {
          formConfig.afterSubmit.message = CONTACT_FORM_COPY.successMessageHtml;
        }
      }

      if (Array.isArray(formConfig.elements)) {
        formConfig.elements.forEach(function (element) {
          if (element.type === 'group') {
            patchLocalizedValue(element.label, CONTACT_FORM_COPY.title);
            patchLocalizedValue(element.description, CONTACT_FORM_COPY.descriptionText);

            if (Array.isArray(element.elements)) {
              element.elements.forEach(patchFieldConfig);
            }
          } else {
            patchFieldConfig(element);
          }
        });
      }

      if (typeof formConfig.html === 'string') {
        formConfig.html = patchStringContent(formConfig.html);
      }
    });
  }

  function replaceTextNodes(root) {
    if (!root || !document.createTreeWalker) {
      return;
    }

    var walker = document.createTreeWalker(root, NodeFilter.SHOW_TEXT);
    var textNode = walker.nextNode();

    while (textNode) {
      var currentText = normalizeText(textNode.nodeValue);
      if (currentText && CONTACT_FORM_TEXT_REPLACEMENTS[currentText] !== undefined) {
        textNode.nodeValue = CONTACT_FORM_TEXT_REPLACEMENTS[currentText];
      }

      textNode = walker.nextNode();
    }
  }

  function setElementText(element, text) {
    if (!element) {
      return;
    }

    element.textContent = text;
  }

  function setElementHtml(element, html) {
    if (!element) {
      return;
    }

    element.innerHTML = html;
  }

  function findFieldRoot(form, fieldId) {
    if (!form) {
      return null;
    }

    var directMatch = form.querySelector('[data-element-id="' + fieldId + '"]');
    if (directMatch) {
      return directMatch;
    }

    var fieldCopy = CONTACT_FORM_COPY.fields[fieldId];
    if (!fieldCopy) {
      return null;
    }

    var candidates = form.querySelectorAll('.globo-form-control');
    var matchedField = null;

    candidates.forEach(function (candidate) {
      if (matchedField) {
        return;
      }

      var label = candidate.querySelector('label .label-content, label');
      var labelText = normalizeText(label && label.textContent);

      if (fieldCopy.currentLabels.indexOf(labelText) !== -1) {
        matchedField = candidate;
      }
    });

    return matchedField;
  }

  function setFieldPresentation(form, fieldId) {
    var fieldCopy = CONTACT_FORM_COPY.fields[fieldId];
    var fieldRoot = findFieldRoot(form, fieldId);

    if (!fieldCopy || !fieldRoot) {
      return;
    }

    var label = fieldRoot.querySelector('label');
    var labelContent = fieldRoot.querySelector('label .label-content');
    var requiredIndicator = fieldRoot.querySelector('.text-danger');
    var input = fieldRoot.querySelector('input, textarea, select');

    if (label) {
      if (labelContent) {
        labelContent.textContent = fieldCopy.baseLabel;
      } else {
        label.textContent = fieldCopy.label;
      }

      label.setAttribute('data-label', fieldCopy.baseLabel);
    }

    if (labelContent) {
      labelContent.setAttribute('data-label', fieldCopy.baseLabel);
    }

    if (requiredIndicator) {
      requiredIndicator.textContent = ' *';
    }

    if (input) {
      input.setAttribute('placeholder', fieldCopy.placeholder);
      input.setAttribute('aria-label', fieldCopy.baseLabel);
    }
  }

  function ensureContactFormStyles() {
    if (document.getElementById('a2p-contact-form-style')) {
      return;
    }

    var style = document.createElement('style');
    style.id = 'a2p-contact-form-style';
    style.textContent = [
      '.globo-form-app [data-a2p-request-type="true"]{width:100%;}',
      '.globo-form-app [data-a2p-request-type="true"] .globo-form-input{width:100%;}',
      '.globo-form-app [data-a2p-request-type="true"] select{display:block;width:100%;min-height:52px;padding:14px 16px;border:1px solid rgba(28,28,28,.18);border-radius:10px;background:#fff;color:#1c1c1c;}',
      '.globo-form-app [data-a2p-request-type="true"] .messages{display:block;min-height:20px;color:#c0392b;margin-top:6px;}',
      '.globo-form-app .message.success .content p:empty{display:none;}',
      '@media (max-width: 767px){.globo-form-app [data-a2p-request-type="true"]{margin-bottom:4px;}}'
    ].join('');

    document.head.appendChild(style);
  }

  function buildRequestTypeField(referenceField) {
    var wrapper = referenceField ? referenceField.cloneNode(false) : document.createElement('div');
    wrapper.setAttribute('data-a2p-request-type', 'true');
    wrapper.setAttribute('data-element-id', 'request-type');
    wrapper.setAttribute('data-type', 'select');
    wrapper.className = referenceField ? referenceField.className : 'globo-form-control layout-1-column';

    var label = document.createElement('label');
    label.className = 'material_filled-label globo-label gfb__label-v2';
    label.setAttribute('for', 'a2p-request-type');
    label.setAttribute('data-label', CONTACT_FORM_COPY.requestType.label);

    var labelContent = document.createElement('span');
    labelContent.className = 'label-content';
    labelContent.setAttribute('data-label', CONTACT_FORM_COPY.requestType.label);
    labelContent.textContent = CONTACT_FORM_COPY.requestType.label.replace(/\s\*$/, '');
    label.appendChild(labelContent);

    var requiredIndicator = document.createElement('span');
    requiredIndicator.className = 'text-danger text-smaller';
    requiredIndicator.textContent = ' *';
    label.appendChild(requiredIndicator);

    var inputWrapper = document.createElement('div');
    inputWrapper.className = 'globo-form-input';

    var select = document.createElement('select');
    select.className = 'material_filled-input';
    select.id = 'a2p-request-type';
    select.name = CONTACT_FORM_COPY.requestType.name;
    select.setAttribute('data-a2p-request-type-select', 'true');
    select.setAttribute('aria-label', CONTACT_FORM_COPY.requestType.label);

    var placeholderOption = document.createElement('option');
    placeholderOption.value = '';
    placeholderOption.textContent = CONTACT_FORM_COPY.requestType.placeholder;
    select.appendChild(placeholderOption);

    CONTACT_FORM_COPY.requestType.options.forEach(function (optionLabel) {
      var option = document.createElement('option');
      option.value = optionLabel;
      option.textContent = optionLabel;
      select.appendChild(option);
    });

    inputWrapper.appendChild(select);

    var errorMessage = document.createElement('small');
    errorMessage.className = 'messages';
    errorMessage.setAttribute('data-a2p-request-type-error', 'true');

    wrapper.appendChild(label);
    wrapper.appendChild(inputWrapper);
    wrapper.appendChild(errorMessage);

    return wrapper;
  }

  function validateRequestType(form) {
    var select = form.querySelector('[data-a2p-request-type-select]');
    var errorMessage = form.querySelector('[data-a2p-request-type-error]');

    if (!select) {
      return true;
    }

    if (select.value) {
      select.removeAttribute('aria-invalid');
      if (errorMessage) {
        errorMessage.textContent = '';
      }
      return true;
    }

    select.setAttribute('aria-invalid', 'true');
    if (errorMessage) {
      errorMessage.textContent = CONTACT_FORM_COPY.requestTypeError;
    }

    select.focus();
    return false;
  }

  function ensureRequestTypeField(form) {
    var formElement = form.querySelector('form');
    if (!formElement) {
      return;
    }

    var existingField = formElement.querySelector('[data-a2p-request-type="true"]');
    if (!existingField) {
      var textareaField = findFieldRoot(formElement, 'textarea');
      var referenceField = textareaField || formElement.querySelector('.globo-form-control');
      var requestTypeField = buildRequestTypeField(referenceField);

      if (textareaField && textareaField.parentNode) {
        textareaField.parentNode.insertBefore(requestTypeField, textareaField);
      } else {
        var targetPanel = formElement.querySelector('.panel') || formElement;
        targetPanel.insertBefore(requestTypeField, targetPanel.firstChild);
      }

      existingField = requestTypeField;
    }

    var select = existingField.querySelector('[data-a2p-request-type-select]');
    if (select && !select.dataset.a2pBound) {
      select.dataset.a2pBound = 'true';
      select.addEventListener('change', function () {
        validateRequestType(formElement);
      });
    }

    if (!formElement.dataset.a2pValidationBound) {
      formElement.dataset.a2pValidationBound = 'true';

      formElement.addEventListener('submit', function (event) {
        if (!validateRequestType(formElement)) {
          event.preventDefault();
          event.stopPropagation();
        }
      }, true);

      formElement.addEventListener('click', function (event) {
        var button = event.target.closest &&
          event.target.closest('button.submit, button.next.submit, button[type="submit"]');

        if (!button) {
          return;
        }

        if (!validateRequestType(formElement)) {
          event.preventDefault();
          event.stopPropagation();
          if (typeof event.stopImmediatePropagation === 'function') {
            event.stopImmediatePropagation();
          }
        }
      }, true);
    }
  }

  function ensureTrackingFields(form) {
    var formElement = form.querySelector('form');

    if (!formElement) {
      return;
    }

    syncPowerfulFormBuilderMetadata(formElement);

    if (formElement.dataset.a2pTrackingBound === 'true') {
      return;
    }

    formElement.dataset.a2pTrackingBound = 'true';

    var resyncTrackingMetadata = function () {
      syncPowerfulFormBuilderMetadata(formElement);
    };

    if (window.requestAnimationFrame) {
      window.requestAnimationFrame(resyncTrackingMetadata);
    }

    window.setTimeout(resyncTrackingMetadata, 150);
    window.setTimeout(resyncTrackingMetadata, 600);
    window.setTimeout(resyncTrackingMetadata, 1500);

    formElement.addEventListener('submit', function () {
      resyncTrackingMetadata();
    }, true);

    formElement.addEventListener('click', function (event) {
      var button = event.target.closest &&
        event.target.closest('button.submit, button.next.submit, button[type="submit"]');

      if (button) {
        resyncTrackingMetadata();
      }
    }, true);
  }

  function rewriteSubmitButtons(form) {
    form.querySelectorAll('button.submit, button.next.submit, .gfb__footer button.submit').forEach(function (button) {
      button.setAttribute(
        'data-submit-text',
        '<span class="spinner"></span>' + CONTACT_FORM_COPY.submitText
      );
      button.innerHTML = '<span class="spinner"></span>' + CONTACT_FORM_COPY.submitText;
    });
  }

  function rewriteSuccessState(form) {
    form.querySelectorAll('.message.success .gfb__content-title').forEach(function (title) {
      setElementText(title, CONTACT_FORM_COPY.successTitle);
    });

    form.querySelectorAll('.message.success .content').forEach(function (content) {
      setElementHtml(content, CONTACT_FORM_COPY.successMessageHtml);
    });
  }

  function rewriteContactFormContainer(form) {
    if (form.dataset.a2pContactReady === 'true') {
      form.querySelectorAll('a[href]').forEach(rewriteAnchor);
      return;
    }

    replaceTextNodes(form);

    var headerTitle = form.querySelector('.header .title, .header .globo-heading');
    var headerDescription = form.querySelector('.header .description, .header .globo-description');

    setElementText(headerTitle, CONTACT_FORM_COPY.title);
    setElementHtml(headerDescription, CONTACT_FORM_COPY.descriptionHtml);

    Object.keys(CONTACT_FORM_COPY.fields).forEach(function (fieldId) {
      setFieldPresentation(form, fieldId);
    });

    rewriteSubmitButtons(form);
    rewriteSuccessState(form);
    ensureRequestTypeField(form);
    ensureTrackingFields(form);

    form.querySelectorAll('a[href]').forEach(rewriteAnchor);
    form.dataset.a2pContactReady = 'true';
  }

  function rewriteContactFormContent() {
    if (
      window.location.pathname !== CONTACT_PAGE_PATH &&
      window.location.pathname !== LEGACY_CONTACT_PAGE_PATH
    ) {
      return;
    }

    patchPowerfulFormBuilderConfig();
    ensureContactFormStyles();

    var forms = document.querySelectorAll('.globo-form-app, .globo-form');

    if (!forms.length) {
      return;
    }

    forms.forEach(function (form) {
      if (form.querySelector('form')) {
        rewriteContactFormContainer(form);
      }
    });

    hydrateNativeContactFormTracking();
  }

  function initializeContactFormRewrite() {
    if (LEGACY_PAGE_REDIRECTS[window.location.pathname]) {
      window.location.replace(LEGACY_PAGE_REDIRECTS[window.location.pathname]);
      return;
    }

    if (
      window.location.pathname === LEGACY_PRIVACY_POLICY_PATH ||
      window.location.pathname === LEGACY_PRIVACY_PAGE_PATH
    ) {
      window.location.replace(A2P_PRIVACY_PAGE_PATH);
      return;
    }

    if (window.location.pathname === LEGACY_CONTACT_PAGE_PATH) {
      window.location.replace(CONTACT_PAGE_PATH);
      return;
    }

    if (window.location.pathname !== CONTACT_PAGE_PATH) {
      return;
    }

    rewriteContactFormContent();

    var observer = new MutationObserver(function () {
      rewriteContactFormContent();
    });

    observer.observe(document.documentElement, {
      childList: true,
      subtree: true
    });

    window.setTimeout(rewriteContactFormContent, 300);
    window.setTimeout(rewriteContactFormContent, 1000);
    window.setTimeout(rewriteContactFormContent, 2500);
    window.setTimeout(rewriteContactFormContent, 5000);
  }

  if (LEGACY_PAGE_REDIRECTS[window.location.pathname]) {
    window.location.replace(LEGACY_PAGE_REDIRECTS[window.location.pathname]);
    return;
  }

  if (
    window.location.pathname === LEGACY_PRIVACY_POLICY_PATH ||
    window.location.pathname === LEGACY_PRIVACY_PAGE_PATH
  ) {
    window.location.replace(A2P_PRIVACY_PAGE_PATH);
    return;
  }

  if (window.location.pathname === LEGACY_CONTACT_PAGE_PATH || isLegacyPath(window.location.pathname)) {
    window.location.replace(CONTACT_PAGE_PATH);
    return;
  }

  document.addEventListener('click', function (event) {
    var anchor = event.target.closest && event.target.closest('a[href]');
    if (anchor) {
      rewriteAnchor(anchor);
    }
  }, true);

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () {
      rewriteAllAnchors();
      initializeContactFormRewrite();
    });
  } else {
    rewriteAllAnchors();
    initializeContactFormRewrite();
  }

  window.setTimeout(rewriteAllAnchors, 1000);
})();
